import React from 'react'
import { useSelector } from 'react-redux'

import LoginRequired from 'components/auth/LoginRequired'
import { SentryErrorBoundary } from 'components/common/SentryErrorBoundary'
import { Dashboard } from 'components/dashboard/Dashboard/Dashboard'

import { getLanguage } from 'ducks/auth'
import { isInternetExplorer } from 'utils/browser'
import { Translate } from 'utils/translate'

const InternetExplorerErrorPage = () => {
  const domain = window.location.host

  return (
    <section style={{ margin: '5rem', alignSelf: 'center' }}>
      <h1>Internet Explorer is not supported.</h1>
      <p>Please visit {domain} with a different web browser.</p>
    </section>
  )
}

export const DashboardApp = () => {
  const language = useSelector(getLanguage)

  if (isInternetExplorer()) return <InternetExplorerErrorPage />

  return (
    <LoginRequired>
      <Translate {...{ language }}>
        <SentryErrorBoundary>
          <Dashboard />
        </SentryErrorBoundary>
      </Translate>
    </LoginRequired>
  )
}
